/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthMainLayoutRouteImport } from './routes/_auth/_main-layout'
import { Route as AuthLoginSuccessRouteImport } from './routes/_auth/login-success'
import { Route as AuthLogoutRouteImport } from './routes/_auth/logout'
import { Route as AuthMainLayoutIndexRouteImport } from './routes/_auth/_main-layout/index'
import { Route as AuthMainLayoutAccountsRouteImport } from './routes/_auth/_main-layout/accounts'
import { Route as AuthMainLayoutCalculatorRouteImport } from './routes/_auth/_main-layout/calculator'
import { Route as AuthMainLayoutOffersRouteImport } from './routes/_auth/_main-layout/offers'
import { Route as AuthMainLayoutPhoneRequestsRouteImport } from './routes/_auth/_main-layout/phone-requests'
import { Route as AuthMainLayoutPhonesRouteImport } from './routes/_auth/_main-layout/phones'
import { Route as AuthMainLayoutUsersRouteImport } from './routes/_auth/_main-layout/users'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMainLayoutRoute = AuthMainLayoutRouteImport.update({
  id: '/_main-layout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginSuccessRoute = AuthLoginSuccessRouteImport.update({
  id: '/login-success',
  path: '/login-success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMainLayoutIndexRoute = AuthMainLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMainLayoutRoute,
} as any)
const AuthMainLayoutAccountsRoute = AuthMainLayoutAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthMainLayoutRoute,
} as any)
const AuthMainLayoutCalculatorRoute =
  AuthMainLayoutCalculatorRouteImport.update({
    id: '/calculator',
    path: '/calculator',
    getParentRoute: () => AuthMainLayoutRoute,
  } as any)
const AuthMainLayoutOffersRoute = AuthMainLayoutOffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AuthMainLayoutRoute,
} as any)
const AuthMainLayoutPhoneRequestsRoute =
  AuthMainLayoutPhoneRequestsRouteImport.update({
    id: '/phone-requests',
    path: '/phone-requests',
    getParentRoute: () => AuthMainLayoutRoute,
  } as any)
const AuthMainLayoutPhonesRoute = AuthMainLayoutPhonesRouteImport.update({
  id: '/phones',
  path: '/phones',
  getParentRoute: () => AuthMainLayoutRoute,
} as any)
const AuthMainLayoutUsersRoute = AuthMainLayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthMainLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthMainLayoutIndexRoute
  '/login-success': typeof AuthLoginSuccessRoute
  '/logout': typeof AuthLogoutRoute
  '/accounts': typeof AuthMainLayoutAccountsRoute
  '/calculator': typeof AuthMainLayoutCalculatorRoute
  '/offers': typeof AuthMainLayoutOffersRoute
  '/phone-requests': typeof AuthMainLayoutPhoneRequestsRoute
  '/phones': typeof AuthMainLayoutPhonesRoute
  '/users': typeof AuthMainLayoutUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthMainLayoutIndexRoute
  '/login-success': typeof AuthLoginSuccessRoute
  '/logout': typeof AuthLogoutRoute
  '/accounts': typeof AuthMainLayoutAccountsRoute
  '/calculator': typeof AuthMainLayoutCalculatorRoute
  '/offers': typeof AuthMainLayoutOffersRoute
  '/phone-requests': typeof AuthMainLayoutPhoneRequestsRoute
  '/phones': typeof AuthMainLayoutPhonesRoute
  '/users': typeof AuthMainLayoutUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/_main-layout': typeof AuthMainLayoutRouteWithChildren
  '/_auth/login-success': typeof AuthLoginSuccessRoute
  '/_auth/logout': typeof AuthLogoutRoute
  '/_auth/_main-layout/accounts': typeof AuthMainLayoutAccountsRoute
  '/_auth/_main-layout/calculator': typeof AuthMainLayoutCalculatorRoute
  '/_auth/_main-layout/offers': typeof AuthMainLayoutOffersRoute
  '/_auth/_main-layout/phone-requests': typeof AuthMainLayoutPhoneRequestsRoute
  '/_auth/_main-layout/phones': typeof AuthMainLayoutPhonesRoute
  '/_auth/_main-layout/users': typeof AuthMainLayoutUsersRoute
  '/_auth/_main-layout/': typeof AuthMainLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login-success'
    | '/logout'
    | '/accounts'
    | '/calculator'
    | '/offers'
    | '/phone-requests'
    | '/phones'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login-success'
    | '/logout'
    | '/accounts'
    | '/calculator'
    | '/offers'
    | '/phone-requests'
    | '/phones'
    | '/users'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth/_main-layout'
    | '/_auth/login-success'
    | '/_auth/logout'
    | '/_auth/_main-layout/accounts'
    | '/_auth/_main-layout/calculator'
    | '/_auth/_main-layout/offers'
    | '/_auth/_main-layout/phone-requests'
    | '/_auth/_main-layout/phones'
    | '/_auth/_main-layout/users'
    | '/_auth/_main-layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_main-layout': {
      id: '/_auth/_main-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthMainLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-success': {
      id: '/_auth/login-success'
      path: '/login-success'
      fullPath: '/login-success'
      preLoaderRoute: typeof AuthLoginSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/logout': {
      id: '/_auth/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_main-layout/': {
      id: '/_auth/_main-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthMainLayoutIndexRouteImport
      parentRoute: typeof AuthMainLayoutRoute
    }
    '/_auth/_main-layout/accounts': {
      id: '/_auth/_main-layout/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AuthMainLayoutAccountsRouteImport
      parentRoute: typeof AuthMainLayoutRoute
    }
    '/_auth/_main-layout/calculator': {
      id: '/_auth/_main-layout/calculator'
      path: '/calculator'
      fullPath: '/calculator'
      preLoaderRoute: typeof AuthMainLayoutCalculatorRouteImport
      parentRoute: typeof AuthMainLayoutRoute
    }
    '/_auth/_main-layout/offers': {
      id: '/_auth/_main-layout/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof AuthMainLayoutOffersRouteImport
      parentRoute: typeof AuthMainLayoutRoute
    }
    '/_auth/_main-layout/phone-requests': {
      id: '/_auth/_main-layout/phone-requests'
      path: '/phone-requests'
      fullPath: '/phone-requests'
      preLoaderRoute: typeof AuthMainLayoutPhoneRequestsRouteImport
      parentRoute: typeof AuthMainLayoutRoute
    }
    '/_auth/_main-layout/phones': {
      id: '/_auth/_main-layout/phones'
      path: '/phones'
      fullPath: '/phones'
      preLoaderRoute: typeof AuthMainLayoutPhonesRouteImport
      parentRoute: typeof AuthMainLayoutRoute
    }
    '/_auth/_main-layout/users': {
      id: '/_auth/_main-layout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthMainLayoutUsersRouteImport
      parentRoute: typeof AuthMainLayoutRoute
    }
  }
}

interface AuthMainLayoutRouteChildren {
  AuthMainLayoutAccountsRoute: typeof AuthMainLayoutAccountsRoute
  AuthMainLayoutCalculatorRoute: typeof AuthMainLayoutCalculatorRoute
  AuthMainLayoutOffersRoute: typeof AuthMainLayoutOffersRoute
  AuthMainLayoutPhoneRequestsRoute: typeof AuthMainLayoutPhoneRequestsRoute
  AuthMainLayoutPhonesRoute: typeof AuthMainLayoutPhonesRoute
  AuthMainLayoutUsersRoute: typeof AuthMainLayoutUsersRoute
  AuthMainLayoutIndexRoute: typeof AuthMainLayoutIndexRoute
}

const AuthMainLayoutRouteChildren: AuthMainLayoutRouteChildren = {
  AuthMainLayoutAccountsRoute: AuthMainLayoutAccountsRoute,
  AuthMainLayoutCalculatorRoute: AuthMainLayoutCalculatorRoute,
  AuthMainLayoutOffersRoute: AuthMainLayoutOffersRoute,
  AuthMainLayoutPhoneRequestsRoute: AuthMainLayoutPhoneRequestsRoute,
  AuthMainLayoutPhonesRoute: AuthMainLayoutPhonesRoute,
  AuthMainLayoutUsersRoute: AuthMainLayoutUsersRoute,
  AuthMainLayoutIndexRoute: AuthMainLayoutIndexRoute,
}

const AuthMainLayoutRouteWithChildren = AuthMainLayoutRoute._addFileChildren(
  AuthMainLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthMainLayoutRoute: typeof AuthMainLayoutRouteWithChildren
  AuthLoginSuccessRoute: typeof AuthLoginSuccessRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthMainLayoutRoute: AuthMainLayoutRouteWithChildren,
  AuthLoginSuccessRoute: AuthLoginSuccessRoute,
  AuthLogoutRoute: AuthLogoutRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
